export default {"src":"/_next/static/media/campusInviteWorking1.4c5983cc.svg","height":699,"width":807,"blurWidth":0,"blurHeight":0};